import { CREATIVE_COLLISION_FIELDS_EXCLUDE, REGULAR_DIMENSIONS_WITH_CREATIVE_COLLISION, reportTypes } from './reports';

export const REPORT_TYPES_WITH_COLLISIONS = [reportTypes.mainReport, reportTypes.pivot];

export const getCollisionWarningParams = props => {
    const checkedCreativeMeasurementsDimensions = props.creativeMeasurementDimensions?.filter(({ checked }) => checked);

    if (!checkedCreativeMeasurementsDimensions?.length) return;

    const selectedMetadataDimensions = props.metadataDimensions?.filter(dimension => !CREATIVE_COLLISION_FIELDS_EXCLUDE.has(dimension.name) && dimension.checked) || [];
    const selectedDimensions = [
        ...props.dimensions,
        ...props.organicInsightsDimensions,
        ...props.attributionInsightsDimensions,
        ...props.searchCampaignDimensions,
    ].filter(dimension => dimension.checked && REGULAR_DIMENSIONS_WITH_CREATIVE_COLLISION.has(dimension.name));

    if (!selectedMetadataDimensions.length && !selectedDimensions.length) return;

    return {
        firstGroupDimensions: checkedCreativeMeasurementsDimensions.map(dimension => dimension.display_name).join('/'),
        secondGroupDimensions: [...selectedMetadataDimensions, ...selectedDimensions]
            .map(dimension => dimension.display_name)
            .join('/'),
    };
};
